import { useEffect, useState } from "react";
import { Package } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Button } from "../ui/button";
import { OutputCard } from "./print/OutputList";

export function PublishKitPanel({ book, sections, onBuilt }) {
  const [kits, setKits] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/books/${book.id}/publish-kits`).then((r) => setKits(r.data));
  useEffect(() => { load(); }, [book.id]); // eslint-disable-line
  const formats = sections.filter((s) => s.id !== "metadata");
  const passing = formats.filter((s) => ["PASS", "NOT VERIFIED"].includes(s.overall));
  const build = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/books/${book.id}/publish-kit`); toast.success(`Publish Kit ready — ${data.included.length} format(s)`); load(); onBuilt?.(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="panel p-5 space-y-3" data-testid="publish-kit-panel">
      <div className="flex flex-wrap justify-between gap-3 items-center">
        <div><p className="eyebrow">One-click Publish Kit</p>
          <p className="text-sm text-slate-400 max-w-2xl" data-testid="publish-kit-summary">Bundles only the formats that fully pass preflight into one ZIP, labelled KDP/eBook, KDP/Paperback, KDP/Hardcover and ACX, with an upload checklist and the book details for each upload form.</p>
          <div className="flex gap-2 flex-wrap mt-2">{formats.map((s) => <span key={s.id} className={`text-[11px] px-2 py-0.5 rounded-full border ${passing.includes(s) ? "border-emerald-700 text-emerald-300" : "border-slate-700 text-slate-500 line-through"}`} data-testid={`kit-format-${s.id}`}>{s.title}</span>)}</div></div>
        <Button onClick={build} disabled={busy || !passing.length} className="bg-amber-600 hover:bg-amber-500" data-testid="build-publish-kit"><Package size={14} className="mr-1" />{busy ? "Bundling…" : passing.length ? `Build kit (${passing.length} format${passing.length > 1 ? "s" : ""})` : "Nothing passes yet"}</Button>
      </div>
      {kits[0] && <OutputCard o={kits[0]} />}
    </div>
  );
}
